import React, {useEffect, useState} from 'react';
import {AtTextarea} from "taro-ui";
import {LabelWidget} from "../../index";

const TTextAreaWidget = (props:any) => {
  const {label, isDisabled, updateWidgetProperty, value:wValue, count, maxLength,
    fontSize,
    color,
    fontStyle,
    inputFontSize,
    inputColor,
    inputFontStyle,
    bgColor,
    borderColor,
    isRequired,
    readonly,
    labelPosition,
    labelAlignment,
    labelWidth,
    placeholder,
    borderBottomColor,
    borderBottomWidth,
    placeholderAlignment
  } = props;
  const [value, setValue] = useState<string>('');
  useEffect(()=>{
    setValue(wValue);
  }, [wValue])
  return (
    <LabelWidget label={label}
                 fontSize={fontSize}
                 color={color}
                 fontStyle={fontStyle}
                 inputFontSize={inputFontSize}
                 inputColor={inputColor}
                 inputFontStyle={inputFontStyle}
                 bgColor={bgColor}
                 borderColor={borderColor}
                 labelAlignment={labelAlignment}
                 labelPosition={labelPosition}
                 labelWidth={labelWidth}
                 required={isRequired}
                 borderBottomColor={borderBottomColor}
                 borderBottomWidth={borderBottomWidth}
                 placeholderAlignment={placeholderAlignment}>
      <AtTextarea disabled={isDisabled||readonly} maxLength={maxLength} count={count} placeholder={placeholder} value={value} onChange={(v:string)=>{
        setValue(v);
        updateWidgetProperty&&updateWidgetProperty(v);
      }} />
    </LabelWidget>
    )
  ;
};

export default TTextAreaWidget;
